module.exports = __webpack_public_path__ + "img/unfold.0a8b6cc1.svg";